module.exports = __webpack_public_path__ + "static/media/macbook03.a1f84bc9.png";